import React, { useEffect, useState } from 'react';
import { processData } from '../data/processData';
import DestinationOverview from '../components/Country/TopDestination/OverviewComponent';
import DestinationTravelGuide from '../components/Country/TopDestination/TravelGuideComponent';
import DestinationThingsToDo from '../components/Country/TopDestination/ThingToDoComponent';
import { useSearchContext } from '../contexts/SearchContext';
import AreaTopDestinations from '../components/Country/AreaDestinationCardComponent';
import Breadcrumbs from '../components/BreadcrumbsComponent';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import WeatherComponentMonth from '../components/WeatherComponentMonth';

interface TopDestinationPageProps {
  countrySlug: string;
  destinationSlug: string;
}

const TopDestinationPage: React.FC<TopDestinationPageProps> = ({ countrySlug, destinationSlug }) => {
  const { checkIn } = useSearchContext();
  const CheckInDate = checkIn.toISOString().split('T')[0];  

  const processedData = processData();
  const country = processedData
    .flatMap(continent => continent.countries)
    .find(country => country.slug === countrySlug);

  const destination = country?.topDestinations.find(destination => destination.slug === destinationSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!country || !destination) {
    return <div>Destination not found</div>;
  }

  const [activeTab, setActiveTab] = useState('overview');

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <DestinationOverview destination={destination} />;
      case 'travel-guide':
        return <DestinationTravelGuide destination={destination} />;
      case 'things-to-do':
        return <DestinationThingsToDo destination={destination} />;
      default:
        return null;
    }
  };

  return (
    <>
    <HelmetProvider>
      <Helmet>
          <title>{destination.metaTitle}</title>
          <meta name="description" content={destination.metaDescription} />
      </Helmet>
    </HelmetProvider>
    <div className='w-full'>
      <h1 className='absolute uppercase text-3xl p-4 md:p-0 md:text-5xl font-bold md:mt-80 md:ml-64 text-white destination-h1'>Holidays to {destination.name}</h1>
      <img src={destination.imageUrl} alt={destination.name} className='w-full h-96 object-cover' />
      <div className='container p-4 md:px-28 2xl:px-40 mx-auto py-10'>
        <div className='pb-4'>
          <Breadcrumbs />
        </div>
        <div className='flex justify-around border-b border-gray-300 md:w-[70%]'>
          <button onClick={() => setActiveTab('overview')} >
            <h2 className={`block px-4 py-2 text-gray-400 text-sm md:text-lg font-semibold ${activeTab === 'overview' ? 'border-b-2 text-gray-800 tab-item-active' : ''}`}>Overview</h2>
          </button>
          <button onClick={() => setActiveTab('travel-guide')} >
            <h2 className={`block px-4 py-2 text-gray-400 text-sm md:text-lg font-semibold ${activeTab === 'travel-guide' ? 'border-b-2 text-gray-800 tab-item-active' : ''}`}>Travel Guide</h2>
          </button>
          <button onClick={() => setActiveTab('things-to-do')} >
            <h2 className={`block px-4 py-2 text-gray-400 text-sm md:text-lg font-semibold ${activeTab === 'things-to-do' ? 'border-b-2 text-gray-800 tab-item-active' : ''}`}>Things To Do</h2>
          </button>
        </div>
  
        <div className='mt-6'>
          {renderContent()}

          <div className='my-4'>
            <h2>{destination.name} weather</h2>
            <p>{destination.weatherDetails}</p>
          </div>
          <WeatherComponentMonth startDate={CheckInDate} latitude={parseFloat(destination.latitude)} longitude={parseFloat(destination.longitude)} />

          {destination.areaDestinations && destination.areaDestinations.length > 0 && (
            <div className='-mt-2'>
              <h2>Top Destinations in {destination.name}</h2>
              <AreaTopDestinations country={country} destination={destination}/>
            </div>
          )}

        </div>
      </div>
    </div>
    </>
  );
};

export default TopDestinationPage;